module.exports = __webpack_public_path__ + "img/user7-128x128.aaee9981.jpg";